import { render, staticRenderFns } from "./ForgotAccount.vue?vue&type=template&id=7075a996&scoped=true"
import script from "./ForgotAccount.vue?vue&type=script&lang=js"
export * from "./ForgotAccount.vue?vue&type=script&lang=js"
import style0 from "./ForgotAccount.vue?vue&type=style&index=0&id=7075a996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7075a996",
  null
  
)

export default component.exports